import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { Link } from 'react-router-dom';

export default function SitemarkIcon() {
  return (
    <Link to="/" style={{ textDecoration: 'none' }}>
      <SvgIcon sx={{ height: 28, width: 120, mr: 2 }}>
        <image
          href="/images/logo.png" // Chemin relatif depuis le dossier public
          width="120"
          height="28"
          x="-50"
          y="0"
          preserveAspectRatio="xMidYMid meet"
        />
      </SvgIcon>
    </Link>
  );
}